import*as i from"yup";const a={email:""},e=i.object().shape({email:i.string().email("Email is not valid").required("Email is required")});export{a as initialValues,e as validationSchema};
